import React, { Component } from 'react';

class CheckAllow extends Component {
    constructor(props) {
        super(props);
        this.changeCheck = this.changeCheck.bind(this);
    }

    changeCheck(event) {
        this.props.changeCheck(event.target.id, event.target.checked);
    }

    render () {
        let permiteCuotas;
        if (this.props.data != undefined && this.props.data != "") {
            permiteCuotas = this.props.tarjetas.tipoEmpresa.aceptaPagos;
        }

        return (
            <div className="row top-separator-xs">
                <div className="col-xs-12">
                    <div className="row">
                        <div className="col-xs-12">
                            <ul className="no-bullets no-padding no-margin">
                                <li className="inlineListItem2 lg-margin">
                                    <div className="default-checkbox">
                                        <input id="chkAdelantos" type="checkbox" onClick={this.changeCheck} checked={this.props.data.CheckAdvance} />
                                        <label className="label-primary" htmlFor="chkAdelantos"></label>
                                    </div>
                                </li>
                                <li className="inlineListItem2">
                                    <label className="label-primary" htmlFor="chkAdelantos">Permite Adelantos</label>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12">
                            <ul className="no-bullets no-padding no-margin">
                                <li className="inlineListItem2 lg-margin">
                                    <div className="default-checkbox">
                                        <input id="chklimite" type="checkbox" onClick={this.changeCheck} checked={this.props.data.CheckLimit} />
                                        <label className="label-primary" htmlFor="chklimite"></label>
                                    </div>
                                </li>
                                <li className="inlineListItem2">
                                    <label className="label-primary" htmlFor="chklimite">Tiene límite por transacción</label>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12">
                            <ul className="no-bullets no-padding no-margin">
                                <li className="inlineListItem2 lg-margin">
                                   <div className="default-checkbox">
                                        <input id="chkConsumos" type="checkbox" onClick={this.changeCheck} checked={this.props.data.CheckForeign} />
                                        <label className="label-primary" htmlFor="chkConsumos"></label>
                                    </div>
                                </li>
                                <li className="inlineListItem2">
                                    <label className="label-primary" htmlFor="chkConsumos">Permite consumos en el exterior</label>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12">
                            <ul className="no-bullets no-padding no-margin">
                                <li className="inlineListItem2 lg-margin">
                                   <div className="default-checkbox">
                                        <input id="chkPermiteCuotas" type="checkbox" onClick={this.changeCheck} checked={this.props.data.CheckPermiteCuotas} />
                                        <label className="label-primary" htmlFor="chkPermiteCuotas"></label>
                                    </div>
                                </li>
                                <li className="inlineListItem2">
                                    <label className="label-primary" htmlFor="chkPermiteCuotas">Permite cuotas</label>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12">
                            <ul className="no-bullets no-padding no-margin">
                                <li className="inlineListItem2 lg-margin">
                                   <div className="default-checkbox">
                                        <input id="chkReporte" type="checkbox" onClick={this.changeCheck} checked={this.props.data.CheckReport} />
                                        <label className="label-primary" htmlFor="chkReporte"></label>
                                    </div>
                                </li>
                                <li className="inlineListItem2">
                                    <label className="label-primary" htmlFor="chkReporte">Reporte cuenta central</label>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12">
                            <ul className="no-bullets no-padding no-margin">
                                <li className="inlineListItem2 lg-margin">
                                   <div className="default-checkbox">
                                        <input id="chkGastos" type="checkbox" onClick={this.changeCheck} checked={this.props.data.CheckExpenses} />
                                        <label className="label-primary" htmlFor="chkGastos"></label>
                                    </div>
                                </li>
                                <li className="inlineListItem2">
                                    <label className="label-primary" htmlFor="chkGastos">Toma los gastos de emisión del resumen del modelo de liquidación</label>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        );

    }
};

export default CheckAllow;